import * as React from 'react';

import { StepProps } from './Stepper';

type useStepper = {
  initialStep: number;
  steps: Pick<
    StepProps,
    'label' | 'description' | 'optional' | 'optionalLabel' | 'icon'
  >[];
};

export type useStepperReturn = {
  nextStep: () => void;
  prevStep: () => void;
  resetSteps: () => void;
  setStep: (step: number) => void;
  activeStep: number;
  isDisabledStep: boolean;
  isLastStep: boolean;
  isOptionalStep: boolean | undefined;
};

export function useStepper({
  initialStep,
  steps,
}: useStepper): useStepperReturn {
  const [activeStep, setActiveStep] = React.useState(initialStep);

  const nextStep = () => {
    setActiveStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setActiveStep((prev) => prev - 1);
  };

  const resetSteps = () => {
    setActiveStep(initialStep);
  };

  const setStep = (step: number) => {
    setActiveStep(step);
  };

  const isDisabledStep = activeStep === 0;

  const isLastStep = activeStep === steps.length - 1;

  const isOptionalStep = steps[activeStep]?.optional;

  return {
    nextStep,
    prevStep,
    resetSteps,
    setStep,
    activeStep,
    isDisabledStep,
    isLastStep,
    isOptionalStep,
  };
}
